import { Context } from '@vue-storefront/core';
import {ApiResult, UserShippingAddressItem as AddressItem} from '../../types';

export default async function customUpdateaddress(context: Context, address: AddressItem): Promise<ApiResult> {
  const url = new URL('/mall/address/add', context.config.api.url);

  const newAddress = {
    address_id: address.addressId,
    first_name: address.firstName,
    last_name: address.lastName,
    street: address.streetName,
    apartment: address.apartment,
    city: address.city,
    state: address.state,
    zip_code: address.zipCode,
    country: address.country,
    phone: address.phoneNumber,
    sort: address.sort,
    is_default: address.isDefault
  };
  const { data: res } = await context.client.post(url.href, newAddress);
  return res;
}
